import {
  POSTCODE_DISTRICT_BOUNDARIES_ID,
  POSTCODE_SECTOR_BOUNDARIES_ID,
} from "../../consts/sources";
import {
  heatmapViewSelector,
  multiPostcodeFeaturesSelector,
} from "../../reducers/matrixProfile/selectors";

import { LAYERS, OUTER, SECTOR } from "../../consts/layers";
import { Layer } from "react-mapbox-gl";
import { memo } from "react";
import { useSelector } from "react-redux";
import { zoomLevelSelector } from "../../reducers/map/selectors";

export const MultiPatternLayer = memo(() => {
  const sources = useSelector((state) => state.sources);
  const multiPostcodeFeatures = useSelector(multiPostcodeFeaturesSelector);
  const isHeatmapOn = useSelector(heatmapViewSelector);
  const zoomLevel = useSelector(zoomLevelSelector);

  const common = {
    type: "fill",
    paint: {
      "fill-pattern": "multi",
      "fill-outline-color": "rgba(0, 0, 0, 1)",
    },
  };

  if (isHeatmapOn || !!!multiPostcodeFeatures) return null;

  return (
    <>
      {sources[POSTCODE_DISTRICT_BOUNDARIES_ID] &&
        zoomLevel === OUTER &&
        Object.keys(multiPostcodeFeatures.OUTER).length > 0 && (
          <Layer
            filter={[
              "in",
              ["id"],
              [
                "literal",
                Object.values(multiPostcodeFeatures.OUTER).map((i) => i.id),
              ],
            ]}
            id={LAYERS.OUTER.MULTI.NAME}
            sourceId={POSTCODE_DISTRICT_BOUNDARIES_ID}
            sourceLayer={LAYERS.OUTER.BOUNDARIES.SOURCE_LAYER}
            {...common}
          />
        )}
      {sources[POSTCODE_SECTOR_BOUNDARIES_ID] &&
        zoomLevel === SECTOR &&
        Object.keys(multiPostcodeFeatures.SECTOR).length > 0 && (
          <Layer
            filter={[
              "in",
              ["id"],
              [
                "literal",
                Object.values(multiPostcodeFeatures.SECTOR).map((i) => i.id),
              ],
            ]}
            id={LAYERS.SECTOR.MULTI.NAME}
            sourceId={POSTCODE_SECTOR_BOUNDARIES_ID}
            sourceLayer={LAYERS.SECTOR.BOUNDARIES.SOURCE_LAYER}
            {...common}
          />
        )}
    </>
  );
});
